const getThumbnailUrl = (imageUrl: string | undefined): string | undefined => {
  if (!imageUrl) return imageUrl;

  const lastSlashIndex = imageUrl.lastIndexOf('/');
  return `${imageUrl.slice(0, lastSlashIndex + 1)}thumb_${imageUrl.slice(lastSlashIndex + 1)}`;
};

export { getThumbnailUrl };
